// extracted by mini-css-extract-plugin
module.exports = {"Card":"-3z78Q9QqzAYhDzcLgK0ig=="};